import _ from "lodash";
export const filterList = (filterInputList, searchTerm, keysToFilter) => {
  const filteredList = _.filter(filterInputList, function (listItem) {
    let combinedItem = "";
    keysToFilter.map(keyItem => {
      combinedItem = combinedItem.concat(_.get(listItem, keyItem, ""));
    });

    if (
      combinedItem
        .replace(/\s/g, "")
        .toLowerCase()
        .includes(searchTerm.replace(/\s/g, "").toLowerCase())
    )
      return listItem;
    else return null;
  });
  return _.compact(filteredList);
};

export const getFilterObject = ({
  searchText,
  grades = {},
  archivalState = "ALL",
  academicYear,
  blockStatus,
  fetchAcademicYearFromCourse = false,
}) => {
  const gradeIds = _.map(grades, grade => grade.id);

  const filterObj = {
    searchText,
    grades: gradeIds,
    archivalState,
    academicYear,
  };

  if (blockStatus) {
    filterObj.blockStatus = blockStatus;
  }

  if (fetchAcademicYearFromCourse) {
    filterObj.fetchAcademicYearFromCourse = fetchAcademicYearFromCourse;
  }

  return filterObj;
};
